import { Skeleton } from 'antd';

export interface TableSkeletonProps {
  /** How many placeholder rows to draw. Default 6 — enough to read as "a table is coming". */
  rows?: number;
  /** Label announced to assistive tech while the rows are loading. */
  label?: string;
}

/**
 * First-load placeholder for a data table (OPSFL-POLISH-1 designed-states pass).
 *
 * Why not the AntD spinner: a centred spinner over an empty grid tells the operator only "wait",
 * and it collapses the layout so the page JUMPS when data lands. Skeleton rows hold the shape of
 * the answer, so the eye is already parked where the first row will appear and the page does not
 * reflow under it. Used as the table's `emptyText` while loading — the real header row stays
 * visible above it, which is itself information (these are the columns you are about to read).
 *
 * Only for the FIRST load. A refresh over existing rows keeps the rows and uses the table's own
 * loading overlay: never blank out data an operator is already reading.
 */
export function TableSkeleton({ rows = 6, label = 'Loading rows' }: TableSkeletonProps) {
  return (
    <div role="status" aria-live="polite" aria-label={label} style={{ padding: '10px 4px' }}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton
          key={i}
          active
          title={false}
          paragraph={{ rows: 1, width: '100%' }}
          style={{ marginBottom: 10 }}
        />
      ))}
    </div>
  );
}
